import { render, staticRenderFns } from "./SingleNode.vue?vue&type=template&id=501fbd08&scoped=true&"
import script from "./SingleNode.vue?vue&type=script&lang=js&"
export * from "./SingleNode.vue?vue&type=script&lang=js&"
import style0 from "./SingleNode.vue?vue&type=style&index=0&id=501fbd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fbd08",
  null
  
)

export default component.exports